import { render, staticRenderFns } from "./TableCardLoader.vue?vue&type=template&id=545c4b34"
import script from "./TableCardLoader.vue?vue&type=script&lang=ts"
export * from "./TableCardLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports